export default __webpack_public_path__ + "static/media/push21.19b4cc44.gif";